var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2Card1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_6955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55339 1.45325C8.37968 1.37401 8.19098 1.33301 8.00006 1.33301C7.80913 1.33301 7.62043 1.37401 7.44672 1.45325L1.73339 4.05325C1.61509 4.10541 1.51451 4.19085 1.4439 4.29915C1.37329 4.40746 1.33569 4.53396 1.33569 4.66325C1.33569 4.79254 1.37329 4.91904 1.4439 5.02734C1.51451 5.13565 1.61509 5.22108 1.73339 5.27325L7.45339 7.87991C7.6271 7.95915 7.8158 8.00015 8.00672 8.00015C8.19765 8.00015 8.38635 7.95915 8.56006 7.87991L14.2801 5.27991C14.3984 5.22775 14.4989 5.14231 14.5695 5.03401C14.6402 4.9257 14.6778 4.7992 14.6778 4.66991C14.6778 4.54062 14.6402 4.41412 14.5695 4.30582C14.4989 4.19751 14.3984 4.11208 14.2801 4.05991L8.55339 1.45325Z",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 8C1.33294 8.12751 1.3692 8.25244 1.43773 8.35997C1.50627 8.46749 1.6042 8.55311 1.71992 8.60667L7.45325 11.2133C7.62606 11.2916 7.81356 11.3321 8.00325 11.3321C8.19295 11.3321 8.38045 11.2916 8.55325 11.2133L14.2733 8.61333C14.3913 8.56029 14.4913 8.47406 14.5611 8.36516C14.631 8.25625 14.6676 8.12937 14.6666 8",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 11.333C1.33294 11.4605 1.3692 11.5854 1.43773 11.693C1.50627 11.8005 1.6042 11.8861 1.71992 11.9397L7.45325 14.5463C7.62606 14.6246 7.81356 14.6651 8.00325 14.6651C8.19295 14.6651 8.38045 14.6246 8.55325 14.5463L14.2733 11.9463C14.3913 11.8933 14.4913 11.8071 14.5611 11.6982C14.631 11.5893 14.6676 11.4624 14.6666 11.333",
    stroke: "#6A7282",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_6955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2Card1);
export default __webpack_public_path__ + "static/media/Icon2card1.e0d65c83e69b9f8c3e1fc6943cf127b8.svg";
export { ForwardRef as ReactComponent };